import { PhoneCall } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "@/lib/site-content";

export default function FloatingCallButton() {
  return (
    <a
      href={PHONE_TEL}
      data-testid="floating-call-button"
      aria-label={`Call ${PHONE_DISPLAY}`}
      style={{ zIndex: 2147483647 }}
      className="hidden md:inline-flex fixed bottom-4 right-4 items-center gap-2 bg-[#FF4500] hover:bg-[#E63E00] text-white font-display font-bold px-5 py-3 shadow-2xl shadow-orange-500/40 rounded-full transition-all active:scale-[0.97] hover:-translate-y-0.5 ring-2 ring-white/40"
    >
      <PhoneCall className="w-4 h-4" strokeWidth={2.7} />
      <span className="text-sm tracking-wide">Call {PHONE_DISPLAY}</span>
    </a>
  );
}
